<script setup lang="ts">
import { toRef } from 'vue';
import type { PulseData } from '@/types/DataTypes';
import PulseTimeAllocationDisplay from './PulseTimeAllocationDisplay.vue';
import { useUserAllocationStats } from '@/composables/usePulseStats';

interface Props {
  userPulses: PulseData;
}

const props = defineProps<Props>();

// Convert props to reactive reference for the composable
const userPulsesRef = toRef(props, 'userPulses');

// Use the centralized user allocation calculation logic
const { stats: userAllocation } = useUserAllocationStats(userPulsesRef);
</script>

<template>
  <div class="w-full">
    <!-- Allocation Bar (includes unallocated) -->
    <div v-if="Object.keys(userAllocation.allocation).length > 0">
      <PulseTimeAllocationDisplay :time-allocation="userAllocation.allocation" :show-unallocated="true" :show-legend="false" />
    </div>
    
    <!-- No data -->
    <div v-else class="text-xs text-gray-400">No data</div>
  </div>
</template>
